import findLastIndex from 'lodash/findLastIndex';

Hop.defineModule('profile-card-carousel', (domRoot, param) => {
    const carouselContainer = domRoot;
    const cardsList = carouselContainer.querySelector('[data-list]');
    const cards = Array.from(cardsList.querySelectorAll('.profile-card'));

    // If we don't display any cards at all, there's not reasons to do anything here.
    if (!cards.length) {
        return;
    }

    const cardOuterWidth = cards[0].outerWidth();
    const leftCtl = carouselContainer.querySelector('[data-slide-left]');
    const rightCtl = carouselContainer.querySelector('[data-slide-right]');

    const carouselClasses = {
        invisible: 'INVISIBLE',
        loaded: 'LOADED',
    };

    let NUMBER_OF_LEFT_HIDDEN_ELEMENTS = 0;
    let NUMBER_OF_RIGHT_HIDDEN_ELEMENTS = 0;

    function isCardInsideCardsList(card) {
        const leftOk = card.offset().left >= carouselContainer.offset().left;
        const rightOk = card.offset().left + card.outerWidth({margin: false}) <= carouselContainer.offset().left + carouselContainer.outerWidth();

        return leftOk && rightOk;
    }

    function setUpBasicStyles() {
        cardsList.style.transform = 'translateX(0)';
    }

    function hideNotInViewportCards() {
        cards.forEach((c) => {
            isCardInsideCardsList(c, {y: false}) ? c.classList.remove(carouselClasses.invisible) : c.classList.add(carouselClasses.invisible);
        });
    }

    function updateNumberOfHiddenElements() {
        NUMBER_OF_LEFT_HIDDEN_ELEMENTS = cards.findIndex((el) => !el.classList.contains(carouselClasses.invisible));
        NUMBER_OF_RIGHT_HIDDEN_ELEMENTS = cards.length - 1 - findLastIndex(cards, (el) => !el.classList.contains(carouselClasses.invisible));
    }

    function updateControls() {
        leftCtl.hidden = NUMBER_OF_LEFT_HIDDEN_ELEMENTS === 0;
        rightCtl.hidden = NUMBER_OF_RIGHT_HIDDEN_ELEMENTS === 0;
    }

    function rightSlideDistance() {
        return cardOuterWidth + cardOuterWidth * NUMBER_OF_LEFT_HIDDEN_ELEMENTS;
    }

    function leftSlideDistance() {
        return cardOuterWidth * (NUMBER_OF_LEFT_HIDDEN_ELEMENTS - 1);
    }

    function slideToRight() {
        cardsList.style.transform = `translateX(-${rightSlideDistance()}px)`;
    }

    function slideToLeft() {
        cardsList.style.transform = `translateX(-${leftSlideDistance()}px)`;
    }

    function updateView() {
        hideNotInViewportCards();
        updateNumberOfHiddenElements();
        updateControls();
        Hop.lazyLoad.update();
        carouselContainer.classList.add(carouselClasses.loaded);
    }

    function setUpListeners() {
        leftCtl.addEventListener('click', slideToLeft);
        rightCtl.addEventListener('click', slideToRight);
        cardsList.addEventListener('transitionend', updateView);
        window.addEventListener('resize', () => Hop.debounce(updateView, 150));
        if (param.gtmOnCardClick) {
            cards.forEach((c) => c.addEventListener('click', () => Hop.gtm.push(param.gtmOnCardClick)));
        }
    }

    // ensure window is loaded before setup carousel to avoid wrong settings based on non styled DOM
    window.addEventListener('load', () => {
        setUpBasicStyles();
        updateView();
        setUpListeners();
    });
});
